// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"349":"f524d516","4643":"e5c0e13e"}[chunkId] + ".chunk.css";
};